export default __webpack_public_path__ + "static/media/preload.2f0e7b96.gif";